

import { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import styles from './styles.module.css'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import GroupsIcon from '@mui/icons-material/Groups';
import { Button, Dialog, DialogContent } from "@mui/material";
import SocialDistanceIcon from '@mui/icons-material/SocialDistance';
import SecaoAdicionar from "./SecaoAdicionar";
import PersonIcon from '@mui/icons-material/Person';
import CloseIcon from '@mui/icons-material/Close';
import { alterarOrdemVinculosWorkflow, buscarVinculosPorWorkflow, encurtarFluxoWorkflow } from "../../../services/api-planejamento-tributario.service";
import MensagemErro from "../../../components/MensagemErro";

export const StrictModeDroppable = ({ children, ...props }) => {
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        const animation = requestAnimationFrame(() => setEnabled(true));

        return () => {
            cancelAnimationFrame(animation);
            setEnabled(false);
        };
    }, []);

    if (!enabled) {
        return null;
    }

    return <Droppable {...props} >{children}</Droppable>;
};

const DragAndDrop = ({ itens, setItens, switchSelected, idWkflProcesso }) => {
    const [openModal, setOpenModal] = useState(false)
    const [selectedDelete, setSelectedDelete] = useState({ index: '', nome: '', id: '', tipo: '' })
    const [substituir, setSubstituir] = useState(false)
    const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
    const [msg, setMsg] = useState('')

    const handleCloseModal = () => {
        setOpenModal(false)
        setSubstituir(false)
    }

    const handleOpenModal = (index, nome, id, tipo) => {
        setSelectedDelete({ index, nome, id, tipo })
        setOpenModal(true)
    }

    const handleOnDragEnd = async (result) => {
        if (!result.destination) return;
        const listaAntiga = itens.map((item, index) => {
            return {
                idUsuario: item.tipo === 'USUARIO' ? item.id : null,
                idGrupoUsuario: item.tipo !== 'USUARIO' ? item.id : null,
                ordem: index + 1
            }
        })
        const reorderedItems = Array.from(itens);
        const [reorderedItem] = reorderedItems.splice(result.source.index, 1);
        reorderedItems.splice(result.destination.index, 0, reorderedItem);
        const listaNova = reorderedItems.map((item, index) => {
            return {
                idUsuario: item.tipo === 'USUARIO' ? item.id : null,
                idGrupoUsuario: item.tipo !== 'USUARIO' ? item.id : null,
                ordem: index + 1
            }
        })
        setItens(reorderedItems);
        try {
            await alterarOrdemVinculosWorkflow({ idWkflProcesso, listaAntiga, listaNova })

        } catch (error) {
            setMsg(error.response.data.mensagem)
            setOpenSnackbarErro(true)

        }

    };

    const handleAtualiza = async () => {
        try {
            const response = await buscarVinculosPorWorkflow(idWkflProcesso)

            const listaItens = response.vinculosProcessosWkfl.map(item => {
                return {
                    id: (item.id).toString(),
                    nome: item.usuario,
                    tipo: item.tipo
                }
            })
            setItens(listaItens)
        } catch (error) {
            setItens([])
            setMsg(error.response.data.mensagem)
            setOpenSnackbarErro(true)
        }

    }

    const handleDelete = async () => {
        const proximoNaLista = itens[selectedDelete.index + 1]

        const body = {
            idWkflProcesso,
            ordem: selectedDelete.index + 1,
            idUsuario: selectedDelete.tipo === 'USUARIO' ? selectedDelete.id : null,
            idGrupoUsuario: selectedDelete.tipo !== 'USUARIO' ? selectedDelete.id : null,
            idUsuarioProximo: proximoNaLista ? (proximoNaLista.tipo === 'USUARIO' ? proximoNaLista.id : null) : null,
            idGrupoUsuarioProximo: proximoNaLista ? (proximoNaLista.tipo !== 'USUARIO' ? proximoNaLista.id : null) : null
        }
        try {
            await encurtarFluxoWorkflow(body);
            handleAtualiza()
        } catch (error) {
            handleAtualiza()
            setMsg(error.response.data.mensagem)
            setOpenSnackbarErro(true)

        }

        const lista = [...itens]
        lista.splice(selectedDelete.index, 1)
        setItens(lista)
        handleCloseModal()
    }

    const handleCloseSnackbarErro = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSnackbarErro(false);
    };

    return (
        <>
            <DragDropContext onDragEnd={handleOnDragEnd}>
                <StrictModeDroppable droppableId="itens">
                    {(provided) => {
                        return (
                            <div {...provided.droppableProps} ref={provided.innerRef}>
                                {itens.length !== 0 ?
                                    <>
                                        {itens.map(({ id, nome, tipo }, index) => (
                                            <div key={id + nome}>
                                                <Draggable draggableId={id + nome} index={index}>
                                                    {(provided) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            className={styles.rowContainer}
                                                        >
                                                            <h2>{index + 1}º</h2>
                                                            <div
                                                                className={styles.rowContent}
                                                            >
                                                                <div className={styles.rowText}>
                                                                    <DragIndicatorIcon />
                                                                    <div className={styles.rowText_content}>
                                                                        {tipo === 'GRUPO_USUARIO'
                                                                            ? <GroupsIcon sx={{ marginRight: '.5rem' }} />
                                                                            : <PersonIcon sx={{ marginRight: '.5rem' }} />
                                                                        }
                                                                        {nome}
                                                                    </div>
                                                                </div>
                                                                <Button
                                                                    // onClick={() => handleDelete(index)}
                                                                    onClick={() => handleOpenModal(index, nome, id, tipo)}
                                                                >
                                                                    <PersonRemoveIcon color="error" />
                                                                </Button>

                                                            </div>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            </div>
                                        ))}
                                    </>
                                    : <h4 className={styles.msgVazio}>Não existem vínculos para este worflow!</h4>}
                                {provided.placeholder}
                            </div>
                        )
                    }}
                </StrictModeDroppable>
            </DragDropContext>
            <Dialog
                open={openModal}
                onClose={handleCloseModal}
                maxWidth='lg'
                fullWidth={substituir}
            >
                <DialogContent>
                    <div className={styles.deleteContent}>
                        <h3>Você esta deletando o {switchSelected ? 'Grupo de Usuários' : 'Usuário'}, {selectedDelete.nome}.</h3> <CloseIcon className={styles.btnClose} onClick={handleCloseModal} /><br />
                        <h4>Deseja encurtar este fluxo ou substituir o responsável deste nível de aprovação?</h4><br />
                        <p><span style={{ color: 'red' }}>*</span>Ao encurtar o fluxo, a sua demanda será, automaticamente, transferida para o próximo responsável pela aprovação.</p>
                    </div>
                    <div className={styles.deleteButtons}>
                        <Button
                            onClick={handleDelete}
                            endIcon={<PersonRemoveIcon />}
                            className={styles.encurtar}
                            variant="outlined"
                        >
                            Encurtar Fluxo
                        </Button>
                        <Button
                            onClick={() => setSubstituir(true)}
                            endIcon={<SocialDistanceIcon />}
                            className={!substituir ? styles.substituir : styles.substituir_disable}
                            variant="contained"
                            disabled={substituir}
                        >
                            Substituir Usuário
                        </Button>
                    </div>
                    {substituir
                        ? <SecaoAdicionar
                            itens={itens}
                            setItens={setItens}
                            selectedDelete={selectedDelete}
                            onClose={handleCloseModal}
                            idWkflProcesso={idWkflProcesso}
                        />
                        : ''}
                </DialogContent>
            </Dialog>
            <MensagemErro
                open={openSnackbarErro}
                handleClose={handleCloseSnackbarErro}
                msg={msg}
            />
        </>
    )
}

export default DragAndDrop